import { animate, useMotionValue, useTransform, motion } from "framer-motion";
import { useEffect, useState } from "react";

interface TypedTextProps {
  text: string;
  delay?: number;
  durationPerCharacter?: number;
  onComplete?: () => void;
}

const TypedText = ({
  text,
  delay = 0.8,
  durationPerCharacter = 0.05,
  onComplete,
}: TypedTextProps) => {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.round(v));
  const display = useTransform(rounded, (v) => text.slice(0, v));

  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const controls = animate(count, text.length, {
      duration: text.length * durationPerCharacter,
      ease: "linear",
      delay,
      onComplete: () => {
        setIsDone(true);
        setTimeout(() => {
          onComplete?.();
        }, 500);
      },
    });
    return controls.stop;
  }, [count, text, delay, durationPerCharacter, onComplete]);

  return (
    <motion.span
      aria-label={text}
      className="inline-block text-[15px] -mt-[5px] text-gray-600 px-3 py-0 rounded-full font-medium mb-4 text-center"
    >
      <motion.span>{display}</motion.span>
      <motion.span
        className="inline-block ml-1 text-gray-600"
        animate={isDone ? { opacity: 0 } : { opacity: [1, 0, 1] }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        |
      </motion.span>
    </motion.span>
  );
};

export default TypedText;
